import { useQuery } from '@tanstack/react-query';
import { isTruthy } from 'corso-types';
import api from '~/api';
import { useStoreId } from '~/providers/StoreUserProvider';
import {
  shippingClaimQueryKey,
  useShippingClaim,
} from '../ShippingClaimReviewProvider';

// ? this file represents all the possible configuration settings that can be provided
// ? by the configured pegasus automation rule set.

export function useShippingClaimLookup() {
  const storeId = useStoreId();
  const shippingClaimId = useShippingClaim().id;

  return useQuery({
    // nested under the claim key so every claim mutation refetches the rule outcomes
    queryKey: [...shippingClaimQueryKey(shippingClaimId, storeId), 'lookup'],
    queryFn: () =>
      api
        .store(storeId)
        .shippingProtection.claim(`${shippingClaimId}`)
        .lookup(),
  });
}

export function useEnabledReorderLocations() {
  const { data } = useShippingClaimLookup();

  return {
    locations: data?.reorderLocations ?? [],
    provider: data?.reorderLocationProvider,
  };
}

export function useShippingClaimSlaAlerts() {
  const { data } = useShippingClaimLookup();

  return data?.slaAlerts ?? [];
}

export function useReorderShippingTitles() {
  const claim = useShippingClaim();
  const { data } = useShippingClaimLookup();
  const originalTitle = claim.originalStoreOrder.shippingTitle;

  const titleOptions =
    data?.reorderShipping?.shippingTitleKind === 'selection'
      ? data.reorderShipping.shippingTitles
      : [data?.reorderShipping?.shippingTitle];

  return [...new Set([originalTitle, ...titleOptions].filter(isTruthy))];
}

export function useIsFinalizeBlocked() {
  const { data } = useShippingClaimLookup();

  return data?.isFinalizeBlocked ?? false;
}

export function useIsReorderGiftCardEnabled() {
  const { data } = useShippingClaimLookup();

  return data?.isGiftCardEnabled ?? false;
}

export function useEnabledShippingResolutionMethods() {
  const { data } = useShippingClaimLookup();

  return data?.resolutionMethods ?? [];
}
